<div class="modal-header modal-header-2">
  <h2 mat-dialog-title class="pageHeader">Confirmation</h2>
  <button type="button" class="close-button" mat-dialog-close aria-label="Close modal"><span class="ion-android-close" area-hidden="true"></span></button>
</div>
<mat-dialog-content>
  <p class="modal-body">Permanently delete this piece of Evidence? This action cannot be undone.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="buttonWrapper">
  <button type="button" class="button" (click)="cancel()">Cancel</button>
  <button type="button" class="button action-alert" (click)="deleteEvidenceFile()">Delete</button>
  </div>
</mat-dialog-actions>
